import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\OrderDemandController::store
* @see app/Http/Controllers/OrderDemandController.php:16
* @route '/poptavka'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/poptavka',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\OrderDemandController::store
* @see app/Http/Controllers/OrderDemandController.php:16
* @route '/poptavka'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\OrderDemandController::store
* @see app/Http/Controllers/OrderDemandController.php:16
* @route '/poptavka'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\OrderDemandController::sent
* @see app/Http/Controllers/OrderDemandController.php:52
* @route '/poptavka/odeslano'
*/
export const sent = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: sent.url(options),
    method: 'get',
})

sent.definition = {
    methods: ["get","head"],
    url: '/poptavka/odeslano',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\OrderDemandController::sent
* @see app/Http/Controllers/OrderDemandController.php:52
* @route '/poptavka/odeslano'
*/
sent.url = (options?: RouteQueryOptions) => {
    return sent.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\OrderDemandController::sent
* @see app/Http/Controllers/OrderDemandController.php:52
* @route '/poptavka/odeslano'
*/
sent.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: sent.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\OrderDemandController::sent
* @see app/Http/Controllers/OrderDemandController.php:52
* @route '/poptavka/odeslano'
*/
sent.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: sent.url(options),
    method: 'head',
})

const OrderDemandController = { store, sent }

export default OrderDemandController